// Single source of truth for workflow-edge styling: the colour/width/dash tokens and the tier derivation shared by
// the forward edges, the self-loops, and the legend swatches — so none of them can drift apart.

export interface EdgeTier {
  stroke: string
  strokeWidth: number
  dashed: boolean
  zIndex: number
}

// Hex (not Chakra tokens) so the diagram and the legend render the exact same colours: green.500 / gray.500 / gray.300.
export const EDGE_COLOR = {
  taken: '#38A169', // an audit row exists for this transition — history that ran
  available: '#718096', // reachable from the current state right now
  unreachable: '#CBD5E0', // a definition edge that can't fire from the current state
} as const

export const DASH_PATTERN = '5 4'
export const MARKER_SIZE = 12

// Bézier curvature: multi-column "skip" edges bow harder to clear the lanes they leap; adjacent edges curve gently.
export const SKIP_CURVATURE = 0.5
export const ADJACENT_CURVATURE = 0.35

// Three exclusive tiers by precedence: taken (green, solid, on top) ▸ can-be-taken (gray, solid) ▸ unreachable
// (muted, dashed, behind). Used by both the forward and self edges so a transition styles identically either way.
export const edgeTier = (taken: boolean, canTake: boolean): EdgeTier =>
  taken
    ? { stroke: EDGE_COLOR.taken, strokeWidth: 2, dashed: false, zIndex: 2 }
    : canTake
      ? { stroke: EDGE_COLOR.available, strokeWidth: 1.5, dashed: false, zIndex: 1 }
      : { stroke: EDGE_COLOR.unreachable, strokeWidth: 1, dashed: true, zIndex: 0 }
